import React from 'react';
import { useDispatch } from 'react-redux';

import Actions from '@app/store/action';
import I18n from '@app/modules/i18n/index';
import { TRANSFER_STATES } from '@app/transfer-bundle/constant/transfer-states';
import Illustration from '@app/component/illustration';

function AccountEmailVerificationFailed() {
  const dispatch = useDispatch();

  function setTransferState() {
    dispatch(Actions.Transfer.setState(TRANSFER_STATES.VERIFY_RESEND));
  }

  return (
    <div className="transfer__contents account-email-verification-failed">
      <div className="account-email-verification-failed__contents">
        <Illustration
          type="transfer-aborted"
          className="account-email-verification-failed__image"
        />
        <h2 className="account-email-verification-failed__title">
          {I18n.t('transfer.account-verification-failed.title')}
        </h2>
        <p className="account-email-verification-failed__body">
          {I18n.t('transfer.account-verification-failed.body')}
        </p>
        <button
          className="account-email-verification-failed__button"
          onClick={setTransferState}
        >
          {I18n.t('transfer.account-verification-failed.cta')}
        </button>
      </div>
    </div>
  );
}

export default AccountEmailVerificationFailed;
